// Mantis #1453 — M001-D029 §5, contract SAPI-D029-004: the link's own
// status, read-only, sourced from real state (decision J — this page must
// never invent a status). `linked` is the explicit, renderable state; an
// unlinked organisation renders honestly rather than being hidden or
// guessed. Cardinality is 1:1 (lead ruling) — there is no installation list,
// only this organisation's one bound realm or none at all.
import React from 'react';
import { formatDateTime } from './normalisers';
import './realmAuthority.css';

export default function RealmAuthorityLinkStatus({ link }) {
  const linked = link?.linked === true;
  const tunnelConnected = link?.tunnelConnected === true;
  return (
    <section className="ra-link-card" data-testid="ra-link-card" aria-label="RealmAuthority link status">
      <header className="ra-link-heading">
        <h3>RealmAuthority</h3>
        {!linked ? (
          <span className="ra-link-state ra-link-state--unlinked" data-testid="ra-link-status">
            No RealmAuthority realm is linked to this organisation.
          </span>
        ) : tunnelConnected ? (
          <span className="ra-link-state ra-link-state--up" data-testid="ra-link-status">
            Linked — RealmAuthority is connected
          </span>
        ) : (
          <span className="ra-link-state ra-link-state--down" data-testid="ra-link-status">
            RealmAuthority is offline.
            {link?.lastSnapshotAt ? ` Last snapshot: ${formatDateTime(link.lastSnapshotAt)}` : ''}
          </span>
        )}
      </header>
      {linked ? (
        <dl className="ra-link-facts">
          {link?.lastSnapshotAt ? <><dt>Last snapshot</dt><dd><time dateTime={link.lastSnapshotAt}>{formatDateTime(link.lastSnapshotAt)}</time></dd></> : null}
        </dl>
      ) : null}
    </section>
  );
}
